var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import CModal from '../modal';
import { fetchCRMBilling } from '../../../http/crm';
const POLL_INTERVAL_MS = 3000;
export default (props) => {
    React.useEffect(() => {
        if (!props.visible) {
            return;
        }
        let cancelled = false;
        let timer = null;
        const tick = () => __awaiter(void 0, void 0, void 0, function* () {
            if (cancelled) {
                return;
            }
            try {
                const billing = yield fetchCRMBilling(props.merchantId);
                if (cancelled) {
                    return;
                }
                if (billing.status === 'ACTIVE') {
                    props.onActive();
                    return;
                }
            }
            catch (_a) {
                // Ignore transient errors; keep polling until the user closes.
            }
            if (!cancelled) {
                timer = setTimeout(tick, POLL_INTERVAL_MS);
            }
        });
        tick();
        return () => {
            cancelled = true;
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [props.visible, props.merchantId]);
    return _jsx(CModal, { visible: props.visible, title: "Waiting for Payment", onClose: props.onClose, nofooter: true, sm: true, children: _jsxs("div", { className: "text-center py-4", children: [_jsx("div", { className: "spinner-border text-primary mb-3", role: "status", children: _jsx("span", { className: "visually-hidden", children: "Loading..." }) }), _jsx("p", { className: "mb-2", children: "Complete your payment in the tab we just opened." }), _jsx("p", { className: "mb-0 small text-muted", children: "This page will update automatically when the payment is confirmed. You can close this window if you cancel the payment." })] }) });
};
